import React from 'react';
import ReactOnRails from 'react-on-rails';

import ErrorBoundary from '@components/ErrorBoundary';
// Side-effect import: installs a global listener that reports React hydration /
// minified React errors to Rollbar with cause-distinguishing context. Imported
// here because every client pack goes through registerWithErrorBoundary, making
// this the single client-side entry point (server.js does not import it).
import '@utils/reportHydrationErrors';

type AnyComponent = React.ComponentType<any>;

function registerWithErrorBoundary(components: Record<string, AnyComponent>) {
  const wrapped: Record<string, AnyComponent> = {};

  for (const [name, Component] of Object.entries(components)) {
    const Wrapped = (props: any) => (
      <ErrorBoundary componentName={name}>
        <Component {...props} />
      </ErrorBoundary>
    );
    Wrapped.displayName = `withErrorBoundary(${name})`;
    wrapped[name] = Wrapped;
  }

  ReactOnRails.register(wrapped);
}

export default registerWithErrorBoundary;
